import { render, staticRenderFns } from "./AgentLoginModal.vue?vue&type=template&id=81fa463c&"
import script from "./AgentLoginModal.vue?vue&type=script&lang=js&"
export * from "./AgentLoginModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports